import { DeliveryLineStatus } from '~/graphql';

import { IDeliveryLine } from './deliveryLines.types';

export const canEditLineInline = (line: IDeliveryLine) =>
    !line.deletedAt && [DeliveryLineStatus.DELIVERED, DeliveryLineStatus.VERIFIED].includes(line.status);
